/*
    Cart Line Item methods and functionality
*/

export default function lineItems() {
    return {
        methods: {
            /////////////////////////////////////////////
            // Line Items
            filterLineItemProperties(data) {
                let output = false;
                if (!!data && !!data.properties) {
                    let dataFormatted = Array.isArray(data.properties) ? data.properties : Object.entries(data.properties);  // we want an array
                    output = dataFormatted.filter( property => {
                        // Ignore hidden props and notes field
                        let key = property[0],
                            isHidden = key[0].toLowerCase() === '_',
                            isNotes = key.toLowerCase() === 'note';
                        return !isHidden && !isNotes
                    })
                    .sort((first, second) => parseInt(first[0].split('|')[0]) - parseInt(second[0].split('|')[0]));
                };

                return output;
            },

            filterLineItemPrices(data) {
                let output = false;
                if (!!data && !!data.properties) {
                    let props = Array.isArray(data.properties) ? Object.fromEntries(data.properties) : data.properties; // we want an object
                    
                    // if totalOptions is 0, then we can use the compareAtPrice as the total, otherwise, we need to use the basePrice 
                    // otherwise the displayed price gets weird, even though the calculations and totals are correct
                    let getBasePrice = //!!props['_totalOptions'] ? props['_basePrice'] :
                    (!!props['_baseCompareAtPrice'] ? props['_baseCompareAtPrice'] : props['_basePrice']);
                    
                    output = {
                        'shown': props['_shownPrice'],
                        'savings': props['_totalSavings'],
                        'total': (+getBasePrice + +props['_totalOptions'])
                    };
                }
                return output; 
            },

            findItemDiscountMessage(data) {
                let output = false;
                if (!!data && !!data.properties) {
                    let propertiesFormatted = Array.isArray(data.properties) ? data.properties : Object.entries(data.properties), // we want an array
                        property = propertiesFormatted.find( prop => prop[0] === '_discountMessage'),
                        message = !!property ? property[1] : false;
                    output = message;
                }
                return output;
            }
        }
    }
}